import gsap from 'gsap'

export const cursorMovement = () => {

	gsap.set('[data-cursor]', { xPercent: -5, yPercent: -5 })
	const cursor = document.querySelector('[data-cursor]')
	const position = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
	const mouse = { x: position.x, y: position.y }

	window.addEventListener('mousemove', e => {
		mouse.x = e.x
		mouse.y = e.y
		gsap.to(cursor, {
			duration: 0.4,
			x: mouse.x,
			y: mouse.y
		})
	})

	let isDragging = false

	document.addEventListener('pointerdown', e => {
		isDragging = true
		mouse.x = e.x
		mouse.y = e.y
		gsap.to(cursor, {
			duration: 0.4,
			x: mouse.x,
			y: mouse.y
		})
	})

	document.addEventListener('pointermove', e => {
		if (isDragging) {
			mouse.x = e.x
			mouse.y = e.y
			gsap.to(cursor, {
				duration: 0.4,
				x: mouse.x,
				y: mouse.y
			})
		}
	})

	document.addEventListener('pointerup', () => {
		isDragging = false
	})

}

export const cursorEvents = () => {

	const cursor = document.querySelector('[data-cursor]')
	const els = document.querySelectorAll('[data-swiper="team"] .swiper-wrapper, [data-swiper="projects"] .swiper-wrapper')

	els.forEach(el => {
		el.addEventListener('mouseenter', e => cursor.classList.add('arrow-movement'))
		el.addEventListener('mouseleave', e => cursor.classList.remove('arrow-movement'))
	})
}

export default () => { }